//Akordeon
'use strict';

(function () {

    $('.accordion__element').mouseenter(function () {
        $('.accordion__element').removeClass('accordion__element--hover');
        $(this).addClass('accordion__element--hover');

        var $artID = $(this).parents('.__js_stats_wrapper').data('id'),
            $accID = $(this).parent().data('id'),
            $imgID = $(this).find('img').data('src');


        //console.log('art:' + $artID + 'gal:' + $galID + ' / img: ' + $imgID);

        sendStats('gallery', 'hover', $artID + ' / ' + $accID, $imgID);
    });

})();
